// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"54dc3653786b0dbb7a82","655":"c81289a078502ca02a1d"}[chunkId] + ".js";
};